import React, { useMemo } from "react";

import { ScheduleProvider } from "../../../context/domain/planning";
import Schedule from "../../../pages/planning/Schedule";
import { getShiftedDate, getWeekStart, today } from "../../../utils/datetime";
import { PROJECT_SCHEDULE_EMBED_CONFIG } from "../constants";
import { useProjectPageContext } from "./ProjectPageContext";

/**
 * Project Schedule tab: embed full Schedule scoped to the current project.
 *
 * @returns {JSX.Element}
 */
const ProjectSchedule = () => {
  const { project } = useProjectPageContext();
  const defaultFilters = PROJECT_SCHEDULE_EMBED_CONFIG.useDefaultProjectFilter
    ? { projectIds: [String(project.id)] }
    : null;
  // Embed opens one week before the current week (not the latest scope block).
  const initialTimelineStart = useMemo(() => {
    const offsetWeeks =
      PROJECT_SCHEDULE_EMBED_CONFIG.timelineStartOffsetWeeks ?? 0;
    return getShiftedDate(getWeekStart(today()), offsetWeeks * 7);
  }, []);

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm shadow-primary-900/5">
      <ScheduleProvider
        defaultFilters={defaultFilters}
        initialTimelineStart={initialTimelineStart}
      >
        <Schedule
          showPageChrome={PROJECT_SCHEDULE_EMBED_CONFIG.showPageChrome}
          title={`Project ${project.number} Schedule`}
          embedded
        />
      </ScheduleProvider>
    </div>
  );
};

export default ProjectSchedule;
